const UNIT_TO_MB = {
  B: 1 / (1024 * 1024),
  bytes: 1 / (1024 * 1024),
  KB: 1 / 1024,
  MB: 1,
  GB: 1024,
  TB: 1024 * 1024,
};

function normalizeToMb(value, unit = "MB") {
  const num = Number(value) || 0;
  const factor = UNIT_TO_MB[unit] ?? 1;
  return num * factor;
}

function formatNumber(num) {
  const fixed = Number(num.toFixed(1));
  return Number.isInteger(fixed) ? String(fixed) : fixed.toFixed(1);
}

/**
 * 格式化存储空间，默认按 MB 展示，>= 1024 MB 时自动转为 GB
 * @param {number|string} value 数值
 * @param {'MB'|'GB'|'KB'|'TB'|'B'|'bytes'} unit 传入值的单位，默认 MB
 * @returns {string}
 */
export function formatStorageSize(value, unit = "MB") {
  const sizeInMb = normalizeToMb(value, unit);
  if (sizeInMb >= 1024) {
    return `${formatNumber(sizeInMb / 1024)} GB`;
  }
  return `${formatNumber(sizeInMb)} MB`;
}
